import { Injectable } from '@angular/core'
import { HttpService } from '@lla-platform/core/core-data-access'
import { Observable } from 'rxjs'
import {
  IFormItem,
  IFormSubmitRequest,
  IGetFormsRequest,
  IGetFormsResponse
} from '../interfaces/form.interface'
import {
  IInspectionComplianceResponse,
  IInspectionWindowsRequest,
  IInspectionWindowsResponse
} from '../interfaces/inspection-compliance.interface'
import { FORM_API_URL } from './form-api-routes'
import { DateService } from '@lla-platform/core/core-util'

@Injectable({
  providedIn: 'root'
})
export class FormService {
  constructor(
    private http: HttpService,
    private dateService: DateService
  ) {}

  getOneForm(formId: string, isWeeklyTireReport = false): Observable<IFormItem> {
    return this.http.get(
      isWeeklyTireReport ? FORM_API_URL.getOneTireReportForm(formId) : FORM_API_URL.getOneForm(formId)
    )
  }

  getInspectionCompliance(): Observable<IInspectionComplianceResponse> {
    return this.http.get(FORM_API_URL.inspectionCompliance)
  }

  adminGetInspectionWindows(): Observable<IInspectionWindowsResponse> {
    return this.http.get(FORM_API_URL.adminInspectionWindows)
  }

  adminUpdateInspectionWindows(
    payload: IInspectionWindowsRequest
  ): Observable<IInspectionWindowsResponse> {
    return this.http.post(FORM_API_URL.adminInspectionWindows, payload)
  }

  getForms(payload: IGetFormsRequest, isWeeklyTireReport = false): Observable<IGetFormsResponse> {
    const { startDate, endDate } = payload
    return this.http.post(isWeeklyTireReport ? FORM_API_URL.getTireReportForms : FORM_API_URL.getForms, {
      ...payload,
      startDate: this.dateService.momentToDateString(startDate),
      endDate: this.dateService.momentToDateString(endDate)
    })
  }

  submitForm(payload: IFormSubmitRequest, isWeeklyTireReport = false): Observable<IFormItem> {
    const formData = new FormData()

    if (payload.formId) {
      formData.append('formId', payload.formId)
    }

    if (payload.locationId) {
      formData.append('locationId', payload.locationId)
    }

    if (payload.formType) {
      formData.append('formType', payload.formType.toString())
    }

    if (payload.reportDate) {
      formData.append('reportDate', `${this.dateService.momentToDateString(payload.reportDate)}`)
    }

    if (payload.reporterName) {
      formData.append('reporterName', payload.reporterName)
    }

    if (payload.formResponse) {
      formData.append('formResponse', payload.formResponse)
    }

    if (payload.total !== undefined && payload.total !== null) {
      formData.append('total', payload.total.toString())
    }

    if (payload.previousAttachmentIds && payload.previousAttachmentIds.length > 0) {
      payload.previousAttachmentIds.forEach((el) => formData.append('previousAttachmentIds', el))
    }

    // Add attachments if any exist
    if (payload.attachments && payload.attachments.length > 0) {
      payload.attachments.forEach((el) => formData.append('attachments', el, el.name))
      payload.attachmentQuestionIndexes?.forEach((el) =>
        formData.append('attachmentQuestionIndexes', el.toString())
      )
    }

    if (payload.additionalData) {
      formData.append('additionalData', payload.additionalData)
    }

    return this.http.post(
      isWeeklyTireReport ? FORM_API_URL.submitTireReportForm : FORM_API_URL.submitForm,
      formData
    )
  }
}
